import {
    GET_PLAYLISTS,
    GET_PLAYLISTS_ERROR,
    GET_PLAYLISTS_LOADING, LOGIN_USER,
    LOGIN_USER_ERROR,
    LOGIN_USER_LOADING
} from "../actions/actionTypes";

const initialState = {
    loading:false,
    error : null,
    token : localStorage.getItem('token'),
    login : {
        loading : false,
        error : false,
    },
    playlists : {
        loading : true ,
        error : null ,
        data : []
    }
}

export default function userReducer (state = initialState, action) {
    switch(action.type){
        //USER PLAYLISTS
        case GET_PLAYLISTS_ERROR:
            return {
                ...state ,
                playlists: {
                    ...state.playlists,
                    error : action.payload,
                    loading : null
                }
            }
        case GET_PLAYLISTS_LOADING:
            return {
                ...state ,
                playlists: {
                    ...state.playlists,
                    loading: true
                }
            }
        case GET_PLAYLISTS:
            return {
                ...state ,
                playlists: {
                    ...state.playlists ,
                    loading: false ,
                    error: null,
                    data : action.payload
                }
            }
        case LOGIN_USER_LOADING:
            return {
                ...state ,
                login : {
                    ...state.login ,
                    loading : true,
                    error : null
                }
            }
        case LOGIN_USER_ERROR :
            return {
                ...state ,
                login : {
                    ...state.login ,
                    loading : false,
                    error : action.payload
                }
            }
        case LOGIN_USER :
            return {
                ...state ,
                token : action.paylaod.token ,
                login : {
                    ...state.login,
                    loading : false ,
                    error:  false
                }
            }
        default: return state
    }
}

